import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
class Testimonial extends Component{
    render(){
        return(
            <React.Fragment>
                <div className="row">
                    <div className="col-lg-12">
                        <Tabs>
                            <div className="row align-items-center">
                                <div className="col-lg-6">
                                    <TabPanel>
                                        <div className="rn-testimonial-content text-left">
                                            <div className="inner">
                                                <p>I bravi programmatori sanno cosa scrivere. I migliori sanno cosa riscrivere.</p>
                                            </div>
                                            <div className="author-info">
                                                <h6><span>Eric Steven Raymond </span> - INFORMATICO E BLOGGER STATUNITENSE.</h6>
                                            </div>
                                        </div>
                                    </TabPanel>        
                                    <TabPanel>
                                        <div className="rn-testimonial-content text-left">
                                            <div className="inner">
                                                <p>I bravi programmatori sanno cosa scrivere. I migliori sanno cosa riscrivere.</p>
                                            </div>
                                            <div className="author-info">
                                                <h6><span>Eric Steven Raymond </span> - INFORMATICO E BLOGGER STATUNITENSE.</h6>
                                            </div>
                                        </div>
                                    </TabPanel> 
                                    <TabPanel>
                                        <div className="rn-testimonial-content text-left">
                                            <div className="inner">
                                                <p>I bravi programmatori sanno cosa scrivere. I migliori sanno cosa riscrivere.</p>
                                            </div>
                                            <div className="author-info">
                                                <h6><span>Eric Steven Raymond </span> - INFORMATICO E BLOGGER STATUNITENSE.</h6>
                                            </div>
                                        </div>
                                    </TabPanel> 
                                    <TabPanel>
                                        <div className="rn-testimonial-content text-left">
                                            <div className="inner">
                                                <p>I bravi programmatori sanno cosa scrivere. I migliori sanno cosa riscrivere.</p>
                                            </div>
                                            <div className="author-info">
                                                <h6><span>Eric Steven Raymond </span> - INFORMATICO E BLOGGER STATUNITENSE.</h6>
                                            </div>
                                        </div>
                                    </TabPanel> 
                                    <TabPanel>
                                        <div className="rn-testimonial-content text-left">
                                            <div className="inner">
                                                <p>I bravi programmatori sanno cosa scrivere. I migliori sanno cosa riscrivere.</p>
                                            </div>
                                            <div className="author-info">
                                                <h6><span>Eric Steven Raymond </span> - INFORMATICO E BLOGGER STATUNITENSE.</h6>
                                            </div>
                                        </div>
                                    </TabPanel> 
                                    <TabPanel>
                                        <div className="rn-testimonial-content text-left">
                                            <div className="inner">
                                                <p>I bravi programmatori sanno cosa scrivere. I migliori sanno cosa riscrivere.</p>
                                            </div>
                                            <div className="author-info">
                                                <h6><span>Eric Steven Raymond </span> - INFORMATICO E BLOGGER STATUNITENSE.</h6>
                                            </div>
                                        </div>
                                    </TabPanel> 
                                    <TabPanel>
                                        <div className="rn-testimonial-content text-left">
                                            <div className="inner">
                                                <p>I bravi programmatori sanno cosa scrivere. I migliori sanno cosa riscrivere.</p>
                                            </div>
                                            <div className="author-info">
                                                <h6><span>Eric Steven Raymond </span> - INFORMATICO E BLOGGER STATUNITENSE.</h6>
                                            </div>
                                        </div>
                                    </TabPanel> 
                                          
                                </div>
                                
                                <div className="col-lg-6 mt_md--40 mt_sm--40">
                                    <TabList className="testimonial-thumb-wrapper">
                                        <Tab>
                                            <div className="testimonial-thumbnai">
                                                <div className="thumb">
                                                    <img src="/assets/images/client/laravel.jpg"  alt="Laravel"/>
                                                </div>
                                            </div>
                                        </Tab>
                                        <Tab>
                                            <div className="testimonial-thumbnai">
                                                <div className="thumb">
                                                    <img src="/assets/images/client/mongodb.jpg" alt="MongoDB"/>
                                                </div>
                                            </div>
                                        </Tab>
                                        <Tab>
                                            <div className="testimonial-thumbnai">
                                                <div className="thumb">
                                                    <img src="/assets/images/client/php.jpg" alt="PHP"/>
                                                     
                                                </div>
                                            </div>
                                        </Tab>
                                        <Tab>
                                            <div className="testimonial-thumbnai">
                                                <div className="thumb">
                                                    <img src="/assets/images/client/sql.jpg" alt="SQL"/>
                                                   
                                                </div>
                                            </div>
                                        </Tab>
                                        <Tab>
                                            <div className="testimonial-thumbnai">
                                                <div className="thumb">
                                                    <img src="/assets/images/client/react.jpg" alt="React"/>
                                                </div>
                                            </div>
                                        </Tab>
                                        <Tab>
                                            <div className="testimonial-thumbnai">
                                                <div className="thumb">
                                                    <img src="/assets/images/client/vue.jpg" alt="Testimonial Images"/>
                                                     
                                                </div>
                                            </div>
                                        </Tab>
                                     
                                        <Tab>
                                            <div className="testimonial-thumbnai">
                                                <div className="thumb">
                                                    <img src="/assets/images/client/shopware.jpg" alt="Testimonial Images"/>
                                                    
                                                </div>
                                            </div>
                                        </Tab>
                                    </TabList>
                                </div>
                            </div>
                        </Tabs>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default Testimonial;